/**
 * 菜单、倍速、Tab、评估区域等配置
 */
import { BASE_URL_MECN } from './map.config';

// 右侧功能菜单列表
export const MENU_LIST = [
  { name: "预报云图", lfag: "itembgc1", url: "/lamb/" },
  { name: "云图评估", lfag: "item" },
  { name: "积冰预报", lfag: "item", url: "/ice/" },
  { name: "颠簸预报", lfag: "item", url: "/dianbo/" },
  { name: "云量预报", lfag: "item", url: "/cloud/" },
  { name: "云底高度预报", lfag: "item", url: "/ydgd/" },
];

// 倍速选项
export const SPEED_OPTIONS = [
  { name: "x 0.5 倍速", flag: false, type: "primary", srcimg: "0.50", srcimgh: "0.5", sd: 800 },
  { name: "x 1 倍速", flag: true, type: "primary", srcimg: "1", srcimgh: "01", sd: 500 },
  { name: "x 2 倍速", flag: false, type: "primary", srcimg: "2", srcimgh: "02", sd: 250 },
  { name: "x 3 倍速", flag: false, type: "primary", srcimg: "3", srcimgh: "03", sd: 100 },
];

// 实况云图 Tab 列表
export const TAB_LIST = [
  { name: "FY4B云图", url: "FY4B" },
  { name: "水汽云图", url: "fy2gW" },
  { name: "可见光云图", url: "fy2gVIS" },
  { name: "红外1云图", url: "fy2gIR1" },
  { name: "红外2云图", url: "fy2gIR2" },
  { name: "红外4云图", url: "fy2gIR4" },
  { name: "真彩云图", url: "fy2gPic" },
];

// 云图评估区域裁剪参数（东北/东南/西南/西北）
export const EVAL_REGIONS = [
  {
    nameclick: "东北", type: "1",
    x: 460, y: 100, width: 620, height: 600,
    bgcimgstyle: { top: "-156px", left: "-373px" },
    canvasstyle: { top: "74px", left: "130px", width: "calc(1076px * 0.4)", position: "relative" },
    x_: 650, y_: 150, width_: 600, height_: 500,
    bgcimgstyle_: { top: "-156px", left: "-365px" },
    canvasstyle_: { top: "74px", left: "130px", width: "calc(1076px * 0.35)", position: "relative" },
  },
  {
    nameclick: "东南", type: "2",
    x: 400, y: 550, width: 600, height: 550,
    bgcimgstyle: { top: "-440px", left: "-305px" },
    canvasstyle: { top: "404px", left: "73px", width: "calc(1089.2px * 0.4)", position: "relative" },
    x_: 400, y_: 550, width_: 800, height_: 650,
    bgcimgstyle_: { top: "-440px", left: "-360px" },
    canvasstyle_: { top: "384px", left: "41px", width: "calc(1089.2px * 0.345)", position: "relative" },
  },
  {
    nameclick: "西南", type: "3",
    x: 0, y: 400, width: 800, height: 500,
    bgcimgstyle: { top: "-358px", left: "-103px" },
    canvasstyle: { top: "297px", left: "-146px", width: "calc(1089.2px * 0.53)", position: "relative" },
    x_: 0, y_: 400, width_: 900, height_: 700,
    bgcimgstyle_: { top: "-340px", left: "-130px" },
    canvasstyle_: { top: "220px", left: "-220px", width: "calc(1089.2px * 0.53)", position: "relative" },
  },
  {
    nameclick: "西北", type: "4",
    x: 10, y: 10, width: 800, height: 600,
    bgcimgstyle: { top: "-206px", left: "-137px" },
    canvasstyle: { top: "0", left: "-137px", width: "calc(1089.2px* 0.543)", position: "relative" },
    x_: 10, y_: 10, width_: 800, height_: 600,
    bgcimgstyle_: { top: "-240px", left: "-180px" },
    canvasstyle_: { top: "-37px", left: "-188px", width: "calc(1089.2px* 0.543)", position: "relative" },
  },
];

// 初始评估列表
export function createInitialPingguList() {
  return [
    { name: "", item: "72", type: 6, url: BASE_URL_MECN },
    { name: "", item: "96", type: 6, url: BASE_URL_MECN },
    { name: "", item: "120", type: 6, url: BASE_URL_MECN },
    { name: "", item: "144", type: 6, url: BASE_URL_MECN },
    { name: "", item: "5", type: 2, url: BASE_URL_MECN },
    { name: "", item: "24", type: 6, url: BASE_URL_MECN },
    { name: "", item: "5", type: 1, url: BASE_URL_MECN },
    { name: "", item: "0", type: 6, url: BASE_URL_MECN },
    { name: "", item: "5", type: 1, url: BASE_URL_MECN },
    { name: "", item: "48", type: 6, url: BASE_URL_MECN },
    { name: "", item: "5", type: 2, url: BASE_URL_MECN },
    { name: "", item: "168", type: 6, url: BASE_URL_MECN },
    { name: "", item: "192", type: 6, url: BASE_URL_MECN, bgcimgstyle: { top: "-136px", left: "-365px" }, canvasstyle: { top: "104px", left: "217px" } },
    { name: "", item: "216", type: 6, url: BASE_URL_MECN, bgcimgstyle: { top: "-136px", left: "-365px" }, canvasstyle: { top: "104px", left: "217px" } },
    { name: "", item: "240", type: 6, url: BASE_URL_MECN, bgcimgstyle: { top: "-136px", left: "-365px" }, canvasstyle: { top: "104px", left: "217px" } },
  ];
}
